
import { Pipe,PipeTransform } from "@angular/core";

@Pipe({
  name: "orderby"
})

export class OrderByPipe implements PipeTransform {
  transform(array:Array<any>, args:any) {

    if(array) {
 
        if(args!=-1)
        {
              array.sort((a, b) => a.sortOrder < b.sortOrder ? -1 : 1);
              
        }
        else
        {
            array.sort((a, b) => a.initialSortOrder < b.initialSortOrder ? -1 : 1);
        }
    

  //    console.log(array);
      return array;
    }
    //
  }
}